import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b57b9834"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "homepage-icon-links",
  class: "section-max-w flex align-c mlr-auto text-blue"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "homepage-link-text midsize-text mlr-auto" }, [
  /*#__PURE__*/_createTextVNode(" Autism "),
  /*#__PURE__*/_createElementVNode("span", { class: "no-wrap-text" }, "Resources >")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "homepage-icon mlr-auto",
  src: "/icons/key-to-success-svgrepo-com.svg",
  alt: "Key to success"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "homepage-link-text midsize-text mlr-auto" }, [
  /*#__PURE__*/_createTextVNode(" How does CARE "),
  /*#__PURE__*/_createElementVNode("span", { class: "no-wrap-text" }, "help? >")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "homepage-icon mlr-auto",
  src: "/icons/team-success-svgrepo-com.svg",
  alt: "Teamwork"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "homepage-link-text midsize-text mlr-auto" }, [
  /*#__PURE__*/_createTextVNode(" Need CARE "),
  /*#__PURE__*/_createElementVNode("span", { class: "no-wrap-text" }, "services? >")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "homepage-icon mlr-auto",
  src: "/icons/meeting-icon.svg",
  alt: "Consultations"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/resources",
      class: "homepage-link-container"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/services",
      class: "homepage-link-container"
    }, {
      default: _withCtx(() => [
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/contact",
      class: "homepage-link-container"
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    })
  ]))
}